// extracted by mini-css-extract-plugin
export default {"title":"Home_title__5a5H3","subtitle":"Home_subtitle__qmxlX"};